export const NOTIFICATION_ENDPOINTS = {
  saveFirebaseToken: "/api/Notification/SaveFirebaseToken",
  getRecentNotifications: "/api/Notification/GetRecentNotifications",
  userTracking: "/api/Notification/UserTrackingApi",
};
